import { TransitionsOptions } from '@mui/material/styles'

export const transitions: TransitionsOptions = {
  duration: {
    shortest: 100,
    shorter: 150,
    short: 200,
    standard: 250,
    complex: 350,
  },
}
